import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Typography,
} from "@mui/material";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { SubscriptionPortalFlow } from "schemas/dashboard";

interface Props {
  open: boolean;
  loading: boolean;
  onClose: () => void;
  openCancel: () => void;
  handleManagePlan: (flow?: SubscriptionPortalFlow) => void;
}

export default function ManageCustomEmailDialog({
  open,
  onClose,
  openCancel,
  loading,
  handleManagePlan,
}: Props) {
  const { subscription } = useContext(SubscriptionContext);
  const customEmailData = subscription?.customEmailData;

  const emailAddress = `${customEmailData?.domainInfo?.username || "hello"}@${
    customEmailData?.domainInfo?.domain
  }`;

  return (
    <Dialog maxWidth="sm" open={open} onClose={onClose}>
      <IconButton
        sx={{
          color: "primary.main",
          fontSize: 14,
          position: "absolute",
          right: 10,
          top: 10,
        }}
        onClick={onClose}
      >
        <Box component="i" className="fa-regular fa-xmark" />
      </IconButton>
      <DialogTitle>Manage Professional Inbox</DialogTitle>
      <DialogContent>
        <Typography paragraph>
          You currently have the domain{" "}
          <Box component="span" sx={{ color: "primary.main", fontWeight: 700 }}>
            {customEmailData?.domainInfo?.domain}
          </Box>
          , which auto-renews annually at ${customEmailData?.domainInfo?.price}
          /year, and a professional inbox at $15/month.
        </Typography>
        <Typography paragraph>
          If you'd like to make changes to the domain or your email address (
          {emailAddress}), please contact us at{" "}
          <Box component="span" sx={{ color: "primary.main", fontWeight: 700 }}>
            hello@onbento.com
          </Box>
          .
        </Typography>
        <Typography paragraph>
          Use the link below to modify your payment method, and see invoice
          history.
        </Typography>

        <LoadingButton
          loading={loading}
          variant="outlined"
          onClick={() => handleManagePlan()}
        >
          Manage Plan
        </LoadingButton>

        {!(customEmailData && customEmailData.cancelAt) && (
          <>
            <Divider sx={{ my: 2 }} />
            <Typography variant="h6" paragraph>
              Cancel
            </Typography>
            <Typography paragraph>
              <strong>
                Ending your subscription will deactivate your professional
                inbox.
              </strong>
            </Typography>
            <Typography paragraph>
              You'll no longer be able to access your inbox at{" "}
              <strong>{emailAddress}</strong>, send or receive emails, and
              access to your custom domain will be removed.
            </Typography>

            <Button variant="outlined" color="secondary" onClick={openCancel}>
              Cancel Subscription
            </Button>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
